// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2N2uQ","image":"Header_image__W1XcA","name":"Header_name__1oMZR","info":"Header_info__1uOjM","infoRow":"Header_infoRow__1GeHq"};